module.exports = __webpack_public_path__ + "static/media/header-chart.03e0dbd4.svg";